import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ItemEntity } from './item.entity';
import { PriceContractEntity } from './price-contract.entity';

@Index('fk_item__id', ['fkItemId'], {})
@Index('fk_price_contract__id', ['fkPriceContractId'], {})
@Index(
	'price_contract_item_constraint',
	['fkPriceContractId', 'fkItemId', 'startDate', 'endDate'],
	{},
)
@Entity('price_contract_item')
export class PriceContractItemEntity extends BaseEntity {
	@Column('int', { name: 'fk_price_contract__id', unsigned: true })
	public fkPriceContractId!: number;

	@Column('int', { name: 'fk_item__id', unsigned: true })
	public fkItemId!: number;

	@Column('date', { name: 'startDate', nullable: true })
	public startDate!: string | null;

	@Column('date', { name: 'endDate', nullable: true })
	public endDate!: string | null;

	@Column('varchar', { name: 'priceType', length: 32 })
	public priceType!: string;

	@Column('varchar', { name: 'priceSource', nullable: true, length: 255 })
	public priceSource!: string | null;

	@Column('decimal', {
		name: 'priceValue',
		nullable: true,
		precision: 15,
		scale: 6,
	})
	public priceValue!: string | null;

	@Column('int', {
		name: 'minimumQuantityAmount',
		nullable: true,
		default: () => "'0'",
	})
	public minimumQuantityAmount!: number | null;

	@Column('int', { name: 'priority', unsigned: true, default: () => "'0'" })
	public priority!: number;

	@ManyToOne(() => ItemEntity, (item) => item.priceContractItems, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_item__id', referencedColumnName: 'id' }])
	public item!: ItemEntity;

	@ManyToOne(
		() => PriceContractEntity,
		(priceContract) => priceContract.priceContractItems,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([{ name: 'fk_price_contract__id', referencedColumnName: 'id' }])
	public priceContract!: PriceContractEntity;
}
